/** Tool definitions: Assistant utilities (skills, batching). */

import type { ToolDefinition } from './types.js';

export const assistantTools = {
  load_skill: {
    name: 'load_skill',
    access: 'read',
    description:
      'Load a specialized analysis skill that provides detailed guidance for complex financial topics. Skills contain expert workflows, formulas, and output templates. Use this when the user asks about: (1) tax-review: comprehensive tax situation analysis, tax planning, year-end review; (2) options-income: cash-secured puts, covered calls, wheel strategy, premium income, win rates, ROC calculations; (3) portfolio-allocation: asset allocation, rebalancing, target portfolios, 60/40, income vs growth strategies, tax-efficient placement. After loading a skill, follow its workflow and use the provided tools to gather data.',
    inputSchema: {
      type: 'object',
      properties: {
        skill: {
          type: 'string',
          enum: ['tax-review', 'options-income', 'portfolio-allocation'],
          description: 'The skill to load. tax-review: tax analysis and planning. options-income: CSP/CC income strategy analysis. portfolio-allocation: allocation and rebalancing guidance.',
        },
      },
      required: ['skill'],
    },
  },
  execute_batch: {
    name: 'execute_batch',
    access: 'write',
    description:
      'Execute multiple tools in a single request to reduce round-trips. Tools are executed sequentially. Use this when you need data from several tools at once.',
    inputSchema: {
      type: 'object',
      properties: {
        calls: {
          type: 'array',
          items: {
            type: 'object',
            properties: {
              name: {
                type: 'string',
                description: 'Tool name (without luminaria_ prefix).',
              },
              parameters: {
                type: 'object',
                description: 'Tool parameters.',
              },
            },
            required: ['name', 'parameters'],
          },
          description: 'Array of tool calls to execute.',
        },
      },
      required: ['calls'],
    },
  },
} satisfies Record<string, ToolDefinition>;
